export default "__VITE_ASSET__13b2eaf8__"